import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Menu.css";
import { useAuth } from "../../Context/AuthContext";
import { ADMIN_EMAIL } from "../../Config/admin";

export default function Menu({ isOpen, setIsOpen }) {

  const { user, logout } = useAuth();
  const menuRef = useRef(null);

  const isAdmin = user && user.email === ADMIN_EMAIL;

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpen]);

  if (!isOpen) return null;

  return (
    <article className="menu-page" ref={menuRef}>

      {/* Not Logged In */}
      {!user && (
        <Link to="/signinandsignup" onClick={() => setIsOpen(false)}>
          Your Account
        </Link>
      )}

      {/* Logged In */}
      {user && (
        <>
          <Link to="/account" onClick={() => setIsOpen(false)}>
            Your Account
          </Link>

          <Link to="/cart" onClick={() => setIsOpen(false)}>
            Your Orders
          </Link>

          {/* Admin Only */}
          {isAdmin && (
            <Link to="/admin/products" onClick={() => setIsOpen(false)}>
              Admin Dashboard
            </Link>
          )}

          <Link
            to="/"
            onClick={() => {
              logout();
              setIsOpen(false);
            }}
          >
            Logout
          </Link>
        </>
      )}

    </article>
  );
}